/**
 * The nearest ancestor that actually scrolls. Both the board and the home
 * grid live inside `.shell__main`, but neither should have to know that —
 * revealing a tile and auto-scrolling a drag both just walk up until they
 * find the box that moves.
 */
export function scrollParent(from: HTMLElement): HTMLElement | null {
  let node = from.parentElement;
  while (node !== null) {
    const overflow = getComputedStyle(node).overflowY;
    if (overflow === 'auto' || overflow === 'scroll') return node;
    node = node.parentElement;
  }
  return null;
}
